export default __webpack_public_path__ + "static/oldCase-303a894837cfd52ea64cd477e67ab150.png";